//
// # IDE Runtime Config
//
// Type declaration for the runtime config injected by AlphaServer into index.html.
// Contains environment-specific values (tenancy, Firebase auth, etc.) that can't
// be baked in at compile time since the same IDE bundle serves all tenancies.
//

export interface GenAlphaConfig {
  tenancy?: string;
  firebase?: {
    apiKey: string;
    authDomain: string;
    projectId: string;
  };
}

declare global {
  interface Window {
    __GENALPHA_CONFIG__?: GenAlphaConfig;
  }
}
